import React, { Component } from "react";
import { StreamChat } from "stream-chat";
import ChatContext from "context/ChatContext";

export default WrappedComponent => {
  return class extends Component {
    state = {
      loading: false,
      error: null
    };

    _setLoading = async loading => {
      await this.setState({
        loading,
        error: null
      });
    };

    _setError = async error => {
      await this.setState({
        error
      });
    };

    render() {
      const { error, loading } = this.state;

      return (
        <ChatContext.Consumer>
          {value => {
            return (
              <WrappedComponent
                loading={loading}
                error={error}
                setLoading={this._setLoading}
                setError={this._setError}
                StreamChat={StreamChat}
                {...this.props}
                {...value}
              />
            );
          }}
        </ChatContext.Consumer>
      );
    }
  };
};
